module.exports = __webpack_public_path__ + "static/media/chevron_up.4e60875f.svg";